export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = null
  if (window.location.href.split('?').length > 1) {
    r = window.location.href.split('?')[1].match(reg)
  } else {
    r = null
  }
  if (r != null) return decodeURI(r[2])
  return null
}




// WEBPACK FOOTER //
// ./src/utils/util.js